
export default {

  setCurrentId (state, id) {
    state.currentId = id
  },

  setCurrentSite (state, site) {
    state.current = site
  },

  setMarkets (state, markets) {
    state.markets = markets
  },

  setSites (state, sites) {
    state.all = sites
  }
}